const objectUtility = {
    // https://stackoverflow.com/questions/12931828/convert-returned-json-object-properties-to-lower-first-camelcase
    // Turns all of the properties camelCased recursively.
    toCamelCase: function (o) {
        const self = this;
        let newO, origKey, newKey, value;
        if (o instanceof Array) {
            return o.map(function (value) {
                if (typeof value === "object") {
                    value = self.toCamelCase(value);
                }
                return value;
            });
        }
        else {
            newO = {};
            for (origKey in o) {
                if (Object.prototype.hasOwnProperty.call(o, origKey)) {
                    if (["OID"].some(k => k === origKey)) {
                        newKey = origKey.toLowerCase();
                    }
                    else if (origKey.endsWith("ID")) {
                        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1, origKey.length - 1) + "d" || origKey).toString();
                    }
                    else {
                        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                    }
                    value = o[origKey];
                    if (value instanceof Array || (value !== null && value?.constructor === Object)) {
                        value = self.toCamelCase(value);
                    }
                    newO[newKey] = value;
                }
            }
        }
        return newO;
    }
};
export default objectUtility;
